// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FQ-z","isFullWidth":"GQ-z","landingPageVideo":"HQ-z","play":"IQ-z","iframeVideo":"JQ-z","playHidden":"KQ-z","fullwidth":"LQ-z"};